 <template>
    <div id="app" style="height:100%">
        <transition name="bounce">
            <router-view></router-view>
        </transition>
    </div>
</template>

<script>
export default {
  name: 'app'
}
</script>
